import { queryOptions } from "@tanstack/react-query";
import { hasClinicAccess } from "@/lib/clinic.functions";

/** Shared, cached "does this user have a clinic relationship?" query. */
export const clinicAccessQuery = () =>
  queryOptions({
    queryKey: ["me", "clinic-access"],
    queryFn: async (): Promise<{ hasClinic: boolean }> =>
      (await hasClinicAccess()) as { hasClinic: boolean },
    staleTime: 5 * 60 * 1000,
  });
